<template>
  <v-layout row wrap>
   <v-flex xs12 sm12 md12>
    <label class="label">
     <div class="label-left-text">{{labelLeftText}}</div>
     <div class="toggle">
      <input class="toggle-state" type="checkbox" name="check" value="check" />
      <div class="indicator"></div>
     </div>
     <div class="label-right-text">{{labelRightText}}</div>
    </label>
   </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    "labelLeftText": {
      type: String,
      default: 'LIVE'
    },
    "labelRightText": {
      type: String,
      default: 'AVG'
    }
  },
}
</script>
<style scoped>
 .label {
  display: inline-flex;
  cursor: pointer;
  color: #394a56;
  display: grid;
  grid-template-columns: 100px 100px 100px;
  padding: 10px;
 }

 .label-left-text {
  margin-right: 16px;
  color: white;
 }

 .label-right-text {
  margin-left: 16px;
  color: white;
 }

 .toggle {
  height: 25px;
  width: 50px;
  border-radius: 15px;
  overflow: hidden;
  background-color: white;
 }

 .toggle-state {
  display: none;
 }

 .indicator {
  height: 100%;
  width: 200%;
  border-radius: 15px;
  transform: translate3d(-75%, 0, 0);
  transition: transform 0.4s cubic-bezier(0.85, 0.05, 0.18, 1.35);
  background: var(--v-accent-base);
 }

 .toggle-state:checked~.indicator {
  transform: translate3d(25%, 0, 0);
 }
</style>